import invariant from 'tiny-invariant';
import { AbstractConnector } from '@web3-react/abstract-connector';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var isIframe = () => {
  try {
    return window.self !== window.top;
  } catch (error) {
    return false;
  }
};
var isLedgerDappBrowserProvider = /*#__PURE__*/(() => {
  var state = null;
  return () => {
    if (typeof state === 'boolean') return state;
    if (typeof window === 'undefined') return false;

    try {
      var params = new URLSearchParams(window.self.location.search);
      var isEmbed = !!params.get('embed');
      state = isIframe() && isEmbed;
    } catch (error) {
      state = false;
    } finally {
      return !!state;
    }
  };
})();

var MAINNET_CHAIN_ID = 1;
class LedgerHQFrameConnector extends AbstractConnector {
  constructor(config) {
    super({
      supportedChainIds: [MAINNET_CHAIN_ID]
    });
    this.config = config;
    this.handleNetworkChanged = this.handleNetworkChanged.bind(this);
    this.handleChainChanged = this.handleChainChanged.bind(this);
    this.handleAccountsChanged = this.handleAccountsChanged.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleNetworkChanged(networkId) {
    this.emitUpdate({
      provider: this.provider,
      chainId: networkId
    });
  }

  handleChainChanged(chainId) {
    this.emitUpdate({
      chainId
    });
  }

  handleAccountsChanged(accounts) {
    this.emitUpdate({
      account: accounts.length === 0 ? null : accounts[0]
    });
  }

  handleClose() {
    this.emitDeactivate();
  }

  isLedgerApp() {
    return isLedgerDappBrowserProvider();
  }

  getProviderInstance() {
    var _this = this;

    return _asyncToGenerator(function* () {
      if (_this.provider) return _this.provider;
      var {
        IFrameEthereumProvider
      } = yield import('@ledgerhq/iframe-provider');
      return new IFrameEthereumProvider(_this.config);
    })();
  }

  activate() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      if (!_this2.provider) {
        _this2.provider = yield _this2.getProviderInstance();
      }

      _this2.provider.on('networkChanged', _this2.handleNetworkChanged);

      _this2.provider.on('chainChanged', _this2.handleChainChanged);

      _this2.provider.on('accountsChanged', _this2.handleAccountsChanged);

      _this2.provider.on('close', _this2.handleClose);

      var accounts = yield _this2.provider.enable();
      var account = accounts[0];
      return {
        provider: _this2.provider,
        account
      };
    })();
  }

  getProvider() {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      return _this3.provider;
    })();
  }

  getChainId() {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      !_this4.provider ? process.env.NODE_ENV !== "production" ? invariant(false, 'Provider is not defined') : invariant(false) : void 0;
      return _this4.provider.send('eth_chainId');
    })();
  }

  getAccount() {
    var _this5 = this;

    return _asyncToGenerator(function* () {
      !_this5.provider ? process.env.NODE_ENV !== "production" ? invariant(false, 'Provider is not defined') : invariant(false) : void 0;
      var accounts = yield _this5.provider.send('eth_accounts');
      var account = accounts[0];
      return account;
    })();
  }

  deactivate() {
    !this.provider ? process.env.NODE_ENV !== "production" ? invariant(false, 'Provider is not defined') : invariant(false) : void 0;
    this.provider.removeListener('networkChanged', this.handleNetworkChanged);
    this.provider.removeListener('chainChanged', this.handleChainChanged);
    this.provider.removeListener('accountsChanged', this.handleAccountsChanged);
    this.provider.removeListener('close', this.handleClose);
  }

}

export default LedgerHQFrameConnector;
export { LedgerHQFrameConnector, isIframe, isLedgerDappBrowserProvider };
//# sourceMappingURL=web3-ledgerhq-frame-connector.esm.js.map
